package com.jet.classroomhero.data.remote.exceptions

// 400 errors
class CHRequestException(error: String = "", message: String = "") : Exception(error)

